import api from "../api/api";

const getBusinessInfo = () =>{
    return new Promise((resolve, reject)=>{
        api.get("/guest/business").then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const getMasters = (masters) => {
    return new Promise((resolve, reject)=>{
        api.get('/guest/system-masters/dd/'+masters.join()).then((res) => {
            //console.log(res.data);
            let allMasters = res.data;
            let data = {};
            for (const master in allMasters) {
                if(!allMasters[master].error){
                    data[master] = allMasters[master].data;
                }
            }
            resolve(data);
        }).catch(error =>{
            reject("Something went wrong while loading masters");
        })
    })
}

const getMastersWithAllOptions = (masters) => {
    return new Promise((resolve, reject)=>{
        api.get('/guest/system-masters/dd/'+masters.join()).then((res) => {
            //console.log(res.data);
            let allMasters = res.data;
            let data = {};
            for (const master in allMasters) {
                if(!allMasters[master].error){
                    data[master] = [{value:0,label:"For All "+master.toLocaleUpperCase()}, ...allMasters[master].data];
                }
            }
            resolve(data);
        }).catch(error =>{
            reject("Something went wrong while loading masters");
        })
    })
}

const hookServices = {
    getBusinessInfo,
    getMasters,
    getMastersWithAllOptions
}
export default hookServices;